module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt3.275027c7a569a33772f054ebac9d3db6.png";